document.addEventListener("DOMContentLoaded", () => {
    const slides = document.querySelectorAll(".slidev8");

    slides.forEach(slide => {
      const playButton = slide.querySelector(".play-buttonv8");
      const pauseButton = slide.querySelector(".pause-buttonv8");
      const video = slide.querySelector("video");
      const source = video.querySelector("source");

      let hidePauseButtonTimeout;

      const showPauseButton = () => {
        pauseButton.classList.remove("hiddenv8");
        clearTimeout(hidePauseButtonTimeout);
        hidePauseButtonTimeout = setTimeout(() => {
          pauseButton.classList.add("hiddenv8");
        }, 1000);
      };

      playButton.addEventListener("click", () => {
        // Load video src only on play
        if (!source.src) {
          source.src = source.dataset.src;
          video.load();
        }

        // Pause other videos
        document.querySelectorAll("video").forEach(v => {
          if (v !== video) {
            v.pause();
            v.classList.remove("playingv8");
          }
        });

        video.play();
        video.classList.add("playingv8");
        playButton.style.display = "none";
        pauseButton.style.display = "flex";
        showPauseButton();
      });

      pauseButton.addEventListener("click", () => {
        video.pause();
        video.classList.remove("playingv8");
        playButton.style.display = "flex";
        pauseButton.style.display = "none";
      });

      video.addEventListener("mousemove", showPauseButton);
      video.addEventListener("click", showPauseButton);

      video.addEventListener("play", () => {
        playButton.style.display = "none";
        pauseButton.style.display = "flex";
        showPauseButton();
      });

      video.addEventListener("pause", () => {
        playButton.style.display = "flex";
        pauseButton.style.display = "none";
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const content = document.getElementById("toc-content");
    const toc = document.getElementById("toc-placeholder");

    if (!toc || !content) return;

    const headings = content.querySelectorAll("h2, h3");

    if (headings.length === 0) return;

    const nav = document.createElement("nav");
    nav.classList.add("toc");

    const list = document.createElement("ul");
    list.classList.add("toc__list");

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = "heading-" + index;
      }

      const item = document.createElement("li");
      const link = document.createElement("a");

      link.href = "#" + heading.id;
      link.textContent = heading.textContent;
      link.classList.add("toc__link");

      if (heading.tagName === "H2") {
        item.classList.add("toc__item", "toc__item--h2");
      } else if (heading.tagName === "H3") {
        item.classList.add("toc__item", "toc__item--h3");
      }

      item.appendChild(link);
      list.appendChild(item);
    });

    nav.appendChild(list);
    toc.replaceWith(nav);
  });
